import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';

const Header = () => {
  const location = useLocation();
  const activePath = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  // const [isModalHistory, setIsModalHistory] = useState(false);

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.Jun88K36
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  const isActive = (href) => {
    if (!href || href === '#') return false;
    if (href === '/' || href === '/prediction') {
      return activePath === '/' || activePath === '/prediction';
    }
    return activePath === href;
  };

  const headerNavItems = [
    { name: 'Dự đoán', href: '/' },
    { name: 'Lịch thi đấu', href: '/match' },
    { name: 'Thể lệ', href: '/rule' },
    { name: 'Lịch sử dự đoán', href: '/history' },
    { name: 'Trang chủ Game', href: settings.link_home || '#' }
  ];

  return (
    <div className="w-full">
      <div
        className="w-full max-w-[1080px] mx-auto rounded-b-[25px]
            flex flex-col items-center justify-center
            py-1 md:py-3
            px-2 md:px-3 lg:px-6"
      >
        <div className="w-full overflow-hidden">
          <div
            className="bg-[#E7F4FE] border-[0.5px] border-[#00122D0F]
              flex items-center justify-between gap-[30px] lg:gap-[90px] px-2 md:px-[20px] py-[10px]
              relative rounded-[10px]"
            style={{
              boxShadow:
                '0px 2px 2.7px 2px #FFFFFF inset, 0px -1px 5.5px 0px #0D99FF33 inset, 0px 4px 7.7px 0px #668BEB21, 0px 1px 0.1px 0px #376EFC40'
            }}
          >
            <Link to={settings.link_home || '#'} className="h-[36px] md:h-[46px] w-auto shrink-0">
              <img
                src="/assets/images/header/logo.png"
                alt="Jun88"
                className="w-full h-full object-contain"
              />
            </Link>

            <div className="hidden md:flex items-center justify-between md:gap-2 lg:gap-5 flex-1">
              {headerNavItems.map((item) => {
                const active = isActive(item.href);
                const commonClassName =
                  'h-[50px] flex items-center justify-center text-[16px] text-center whitespace-nowrap';
                const textClassName = active
                  ? 'font-bold text-[color:var(--color-header-nav-active)] underline'
                  : 'font-medium text-[color:var(--color-header-nav-text)]';

                if (item.href?.startsWith('http')) {
                  return (
                    <a
                      key={item.name}
                      href={item.href}
                      className={`${commonClassName} ${textClassName}`}
                    >
                      {item.name}
                    </a>
                  );
                }

                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`${commonClassName} ${textClassName}`}
                  >
                    {item.name}
                  </Link>
                );
              })}
            </div>

            <div className="md:hidden flex bg-[#26A8DF] px-2 py-2 rounded-lg items-center justify-center">
              <a
                className="text-white font-semibold text-sm"
                key={headerNavItems[4].name}
                href={headerNavItems[4].href}
              >
                {'Trang Chủ Game'}
              </a>
            </div>

            <div className="absolute inset-0 pointer-events-none rounded-[10px] shadow-[var(--shadow-header-nav-inset)]" />
          </div>
        </div>

        <div className="flex flex-col w-full max-w-[850px] py-2 items-center justify-center mx-auto">
          {/* <Link to={settings.link_home || '#'}> */}
          <img
            src="/assets/images/header/banner.gif"
            alt="Logo jun88k36"
            className="w-full h-auto object-contain"
          />
          {/* </Link> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
